<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มประเภทพนักงาน</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>{{
              employeeTypeInit.employee_type_code
            }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ employeeTypeInit.title_th }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">
          รหัสประเภทพนักงาน
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="employeeType.employee_type_code"
          :rules="[
            (v) => !!v || 'โปรดระบุรหัสประเภทพนักงาน',
            (v) =>
              (v && v.length >= 1 && v.length <= 32) ||
              'รหัสประเภทพนักงานต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
          ]"
          required
          clearable
          @change="checkEmpty($event, 'employee_type_code')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          ชื่อประเภทพนักงาน
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="employeeType.title_th"
          :rules="[
            (v) => !!v || 'โปรดระบุชื่อประเภทพนักงาน',
            (v) =>
              !v ||
              (v && v.length <= 100) ||
              'ชื่อประเภทพนักงานต้องน้อยกว่า 100 ตัวอักษร',
          ]"
          required
          clearable
          @change="checkEmpty($event, 'title_th')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2"> ชื่อประเภทพนักงาน (อังกฤษ) </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="3"
          v-model="employeeType.title_en"
          :rules="[
            (v) =>
              !v ||
              (v && v.length <= 100) ||
              'ชื่อประเภทพนักงานต้องน้อยกว่า 100 ตัวอักษร',
          ]"
          clearable
          @change="checkEmpty($event, 'title_en')"
          outlined
          dense
        ></v-text-field>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isEmployeeTypeDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::employee_type:delete')"
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::employee_type:create')"
            tabindex="4"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::employee_type:update')"
            tabindex="4"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    employeeType: {
      type: Object,
    },
    employeeTypeInit: {
      type: Object,
    },
  },
  data() {
    return {
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isEmployeeTypeDataChange() {
      if (
        this.employeeType.employee_type_code !==
          this.employeeTypeInit.employee_type_code ||
        this.employeeType.title_th !== this.employeeTypeInit.title_th ||
        this.employeeType.title_en !== this.employeeTypeInit.title_en
      ) {
        this.$emit('isEmployeeTypeDataChange', true)
        return true
      }
      this.$emit('isEmployeeTypeDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      addEmployeeType: 'employeeType/addEmployeeType',
      editEmployeeType: 'employeeType/editEmployeeType',
      deleteEmployeeType: 'employeeType/deleteEmployeeType',
    }),
    checkEmpty(value, field) {
      if (value) {
        this.employeeType[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบประเภทพนักงาน',
        value: this.employeeType.title_th,
        item: this.employeeType,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(employeeType) {
      const { company_uuid: companyUUID } =
        this.$store.state.authentication.company

      this.confirmDialogDeleteLoading = true

      this.deleteEmployeeType({
        companyUUID,
        employeeTypeUUID: employeeType.employee_type_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', this.formAction)
          // this.$refs.form.reset()
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        if (!this.employeeType.title_en) {
          this.employeeType.title_en = null
        }

        const { company_uuid: companyUUID } =
          this.$store.state.authentication.company

        this.addEmployeeType({
          companyUUID,
          employeeType: this.employeeType,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$refs.form.resetValidation()
            this.$emit('formActionCompleted', this.formAction)
            // this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        const { company_uuid: companyUUID } =
          this.$store.state.authentication.company

        this.$store.state.loading = true

        this.editEmployeeType({
          companyUUID,
          employeeTypeUUID: this.employeeType.employee_type_uuid,
          employeeType: this.employeeType,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$refs.form.resetValidation()
            this.$emit('formActionCompleted', this.formAction)
            // this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isEmployeeTypeDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.form.resetValidation()
        this.$emit('formActionCompleted', this.formAction)
        // this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$refs.form.resetValidation()
      this.$emit('formActionCompleted', this.formAction)
      // this.$refs.form.reset()
    },
    onReset() {
      if (this.formAction === 'add' || this.formAction === '') {
        this.$refs.form.resetValidation()
        // this.$refs.form.reset()
      } else {
        this.$emit('onReset', this.formAction)
      }
    },
  },
}
</script>
